const notify = useNotify()

/**
 * 401: Not logged in
 * Jump to the login page if not logged in,
 * and carry the path of the current page
 * Return to the current page after successful login.
 * This step needs to be operated on the login page.
 *
 * 404: Request does not exist
 */

export function checkStatus(status: number, msg: string): void {
  const errMessage = msg || `sys.api.errMsg${status}`

  if (errMessage) notify.error(errMessage)
}
